import React, { useState } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { Button } from '@mui/material';
import AutoCarousel from '../../Helpers/Widgets/AutoCarousel/AutoCarousel';
import ModalArticle from './ModalArticle'
import Data from './Data';
import PropTypes from 'prop-types';
import VideoButton from '../ProductSpecifications/VideoButton/VideoButton';

import './Articles.scss';

function Article(props) {
  const imageSrc = props.product === "term" ? props.data.termImage : props.data.image;
  return (
    <Col className="article">
      <div className="center-sm">
        <Image src={imageSrc} roundedCircle alt="" />
      </div>
      <h3 id={props.index}>{props.data.title}</h3>
      <p>{props.data.teaser}</p>
      <div className="center-sm">
        <Button aria-describedby={props.index} variant="text" color="primary" onClick={() => props.openModal(props.data)}>READ MORE</Button>
      </div>
    </Col>
  )
}

export default function Articles(props) {

  const [modalContent, setModalContent] = useState(null);
  const [isOpenModal, setIsOpenModal] = useState(false);

  function openModal(article) {
    setModalContent(article);
    setIsOpenModal(true);
  }

  var data = [];

  Data().forEach((d, index) => { if (props.articleKeys.includes(index)) { data.push(d) } })
  var articles = data.map((d, index) => <Article key={index} index={index} data={d} openModal={(article) => openModal(article)} product={props.product} />)
  var articleTitle = props.title ? props.title : "Learn about Life Insurance";
  return (
    <div className="articles justify-content-center">
      <Container>
        {modalContent && <ModalArticle isOpen={isOpenModal} animation={false} closeModal={() => setIsOpenModal(false)} title={modalContent.title} paragraphs={modalContent.paragraphs} />}
        <Row className="justify-content-center">
          <h2 className="article-title">{articleTitle}</h2>
        </Row>
        <Row className="large-screen">
          {articles}
        </Row>
        <div className="small-screen">
          <AutoCarousel data={articles} />
        </div>
        {props.videoData &&
          <Row className="justify-content-center">
            <VideoButton title={props.videoData.name} link={props.videoData.link} />
          </Row>
        }
      </Container >
    </div >
  )
}

Articles.propTypes = {
  articleKeys: PropTypes.array.isRequired,
}
